import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LowBattery(props) {
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      className: S.locatorError,
      src: "https://recovr-ui-assets.storage.googleapis.com/locator-error.png",
      alt: "Locator warning",
      height: 136,
      width: 136
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Locator Can Not Be Sold"
    }), /*#__PURE__*/_jsx(Text, {
      children: "This Locator\u2019s battery is too low to be sold to a RecovR customer. Please select a new Locator to pair to this vehicle."
    })]
  });
}
LowBattery.TYPE = 'lowBatteryPending';